module.exports = __webpack_public_path__ + "static/media/folder-arrow-down.57e7f085.svg";